import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import store,{persistor} from './redux/store';
import { PersistGate } from "redux-persist/integration/react";
import env from './config.json'

const {NODE_ENV} =env

const root = ReactDOM.createRoot(document.getElementById('root'));
if (NODE_ENV === 'PRODUCTION') {
  // Disable all console logs
  // console.log = function () {};
  // console.warn = function () {};
  // console.error = function () {};
}
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
    <App />
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
